import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import { LastAndFood, searchFoodRegexp } from '../../../hooks/useFood'
import { NutrientsItem } from '../../../component/NutrientsItem'
import { PressDiv } from '../../../component/PressDiv/PressDiv'
// import cl from './index.module.scss';


type Props = {
    mode: 'click' | 'selection'
    isSelected: boolean
    food: LastAndFood
    search: string
    click: (food: LastAndFood) => void
    select?: (food: LastAndFood) => void
    unselect?: (food: LastAndFood) => void
}

export const FoodItem: React.FunctionComponent<Props> = ({ food, search, ...props }) => {
    const [name, setName] = useState(food.f.name as ReactNode | string)
    useEffect(() => {
        const version = search
        if (search.length > 0) {
            if (version != search) {
                return
            }
            const arr = food.f.name.split(searchFoodRegexp(search))
            if (arr.length != 5) {
                setName(name)
            } else {
                setName(<span>{
                    arr.slice(1, -1).map((text, i) => {
                        if (i == 1) {
                            return <span key={text + '-' + i} style={{ color: 'orange' }}>{text}</span>
                        } else {
                            return <span key={text + '-' + i}>{text}</span>
                        }
                    })
                }</span>)
            }
        } else {
            setName(food.f.name)
        }
    }, [search])
    return (
        <FoodItemContent mode={props.mode}
            isSelected={props.isSelected}
            food={food}
            name={name}
            click={props.click}
            select={props.select}
            unselect={props.unselect} />
    )
}

type FoodItemContentProps = {
    mode: 'click' | 'selection'
    isSelected: boolean
    food: LastAndFood
    name: ReactNode | string
    click: (food: LastAndFood) => void
    select?: (food: LastAndFood) => void
    unselect?: (food: LastAndFood) => void
}
const FoodItemContent: React.FunctionComponent<FoodItemContentProps> = ({ mode, isSelected, food, name, select, unselect, ...props }) => {
    const click = useCallback(() => {
        if (mode === 'click') {
            props.click(food)
        } else {
            if (isSelected) {
                unselect?.(food)
            } else {
                select?.(food)
            }
        }
    }, [mode, food, props.click, select, unselect, isSelected])
    const longPress = useCallback(() => {
        if (isSelected) {
            unselect?.(food)
        } else {
            select?.(food)
        }
    }, [isSelected, food, select, unselect])
    return (
        <>
            <PressDiv onPress={click} onLongPress={longPress}
                style={{
                    padding: '2px 0px', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end',
                }}
            >
                <div style={{ flex: '1 0 auto', paddingBottom: 4, maxWidth: '100%',
                    boxSizing: 'border-box',
                    paddingLeft: 8, paddingRight: 8 }}>
                    {isSelected ? <span style={{ paddingRight: 4, fontSize: '70%' }}>✅</span> : undefined}
                    <span>{name}</span>
                </div>
                <div className='nuts' style={{ width: 220, paddingBottom: 4, alignItems: 'center', marginRight: 10 }}>
                    <NutrientsItem nutrients={food.f} ext={'no'}/>
                </div>
            </PressDiv>
            <div style={{ width: 150, margin: '4px auto 8px auto', borderBottom: '1px solid #ccc' }}/>
        </>
    )
}

